import './Index.css'

export default function Index(props: any) {

    return (<div className="commons-page">
        <h1> 欢迎登录 兴宝月禧商城中台</h1>
    </div>)
}